// Wrapper around our Typography Text
import withTypography from './withTypography'
import Text from '../components/ui/Typography/Text'

export default withTypography(Text)
